import { Button, message, Modal } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { logoutUser } from "../controller/services/auth";
import i18n from "../localization/i18n";
import { setLoading } from "../redux/slices/common_slice";
import { setUserData } from "../redux/slices/user_slice";
import { routePaths } from "../routing/routePaths";
import { clearLocalStoragenNavigate } from "../utils/helper";

const LogoutModal = ({ open, onClose }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const logoutHandler = () => {
    dispatch(setLoading(true));
    logoutUser()
      .then((resp) => {
        message.success(resp?.message?.[i18n.language]);
        clearLocalStoragenNavigate(
          dispatch,
          navigate,
          setUserData,
          onClose,
          routePaths.login
        );
      })
      .catch((Err) => {
        message.error(Err.message?.[i18n.language]);
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };

  return (
    <>
      <Modal
        width="368px"
        title={false}
        open={open}
        onOk={onClose}
        onCancel={onClose}
        className="custom-common-modal"
        centered
        closeIcon={false}
        footer={false}
      >
        <div className="row modal-main-inner-row">
          <div className="col-12 text-center">
            <img
              src="/assets/images/icons/delete-account-icon.svg"
              className="img-fluid"
              alt=""
            />
            <p className="auth-modal-descripation">{t("settings.logoutMsg")}</p>
            <div className="row modal-footer-row mt-0">
              <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                <Button onClick={logoutHandler}>{t("settings.yes")}</Button>
              </div>
              <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                <Button type="primary" onClick={onClose}>
                  {t("settings.no")}
                </Button>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default LogoutModal;
